import { render, staticRenderFns } from "./SimilarPanel.vue?vue&type=template&id=7c0310e1&scoped=true&"
import script from "./SimilarPanel.vue?vue&type=script&lang=js&"
export * from "./SimilarPanel.vue?vue&type=script&lang=js&"
import style0 from "./SimilarPanel.vue?vue&type=style&index=0&id=7c0310e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0310e1",
  null
  
)

export default component.exports